module.exports = __webpack_public_path__ + "static/img/product-swipe22.8739086d.png";